module.exports = __webpack_public_path__ + "img/2_38.df7ca2c5.png";